import Fetcher from "../../libs/Petition";

const url = '/incidents';
const CREATED = 201;
const STATUS_OK = 200;

/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param fibra_id Se utiliza el identificador de la fibra para obtener los roles que le corresponden
 * @param page Se utiliza para conocer la página en la que se encuentra
 * @param pageSize Se utiliza para especificar el tamaño de la página, es decir, la cantidad de registros que se obtendrán.
 * @param user_id [Opcional] Se usa para obtener únicamente los registros de un cliente
 * @param status [Opcional] Se usa para filtrar resultados a través de su estado
 * @param incident_type_id [Opcional] Se usa para filtrar resultados a través del identificador de tipo de incidente
 * @returns Object {"data" => Invoice::collection(),"totalItems" => Cantidad de registros existentes}
 */
export const indexIncident = async (props) => {
    const {
        headers,
        fibra_id,
        page,
        pageSize,
        user_id,
        status,
        incident_type_id } = props;
    let response = [];
    try {
        // Parámetros requeridos
        let params = { fibra_id, page, pageSize };
        // Parámetros opcionales
        if (user_id) params.user_id = user_id;
        if (status) params.status = status;
        if (incident_type_id) params.incident_type_id = incident_type_id;
        let fetch = await Fetcher({
            url: `${url}`,
            method: 'GET',
            params,
            headers
        });
        if (fetch.status === STATUS_OK)
            response = fetch.data;
    } catch (error) {
        response = [];
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param incident_id Identificador del incidente sobre el que se hará la consulta
 * @returns Incident Retorna un objeto tipo Incident
 */
export const showIncident = async ({ headers, incident_id }) => {
    let response = [];
    try {
        let fetch = await Fetcher({
            url: `${url}/${incident_id}`,
            method: 'GET',
            headers
        });
        if (fetch.status === STATUS_OK)
            response = fetch.data.data;
    } catch (error) {
        response = [];
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param data Contiene el objeto que se va a almacenar 
 * @returns Bool Retorna true si el objeto se almacena de manera satisfactoria, retorna FALSE si el objeto no se pudo almacenar 
 */
export const storeIncident = async ({ headers, data }) => {
    let response = true;
    try {
        let fetch = await Fetcher({
            url: `${url}`,
            method: 'POST',
            data,
            headers
        });
        if (fetch.status !== CREATED)
            response = fetch.data;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param data Contiene el objeto que se va a actualizar
 * @param incident_id Identificador del incidente que se va a modificar
 * @returns Bool Retorna true si el objeto se actualiza de manera satisfactoria, retorna FALSE si el objeto no se pudo actualizar 
 */
export const updateIncident = async ({ headers, data, incident_id }) => {
    let response = false;
    try {
        let fetch = await Fetcher({
            url: `${url}/${incident_id}`,
            method: 'PUT',
            data,
            headers
        });
        if (fetch.status === STATUS_OK)
            response = fetch.data;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param incident_id Identificador del incidente que se va a eliminar
 * @returns Bool Retorna true si el objeto se elimina de manera satisfactoria, retorna FALSE si el objeto no se pudo eliminar 
 */
export const destroyIncident = async ({ headers, incident_id }) => {
    let response = true;
    try {
        let fetch = await Fetcher({
            url: `${url}/${incident_id}`,
            method: 'DELETE',
            headers
        });
        if (fetch.status !== STATUS_OK)
            response = false;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}